const strongerEmailValidater = (email: string) => {
  const emailPattern =
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi;
  return emailPattern.test(email.trim());
};

export const isValidEmail = (email: string) => {
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return pattern.test(email.trim()) && strongerEmailValidater(email);
};

const VALID_PATIENT_CODE_CHARACTERS =
  '!123456789abcdefghijk@mn&pqrstuvwxyzABCDEFGH$JKLMN#PQRSTUVWXYZ-_';

export const validatePatientCode = (value: string): boolean => {
  if (value.length < 6) {
    return false;
  }
  for (let i = 0; i < value.length; i++) {
    if (VALID_PATIENT_CODE_CHARACTERS.indexOf(value[i]) === -1) {
      return false;
    }
  }
  return true;
};
